import {
  FilterProps,
  MainOperatorEnum,
  SingleFilterClause,
} from 'store/composableFiltersSlice';

export interface FilterDtoProps {
  filter: {
    filter_operator: MainOperatorEnum;
    filters: any[];
  };
}

export class FiltersDto {
  data: FilterDtoProps;

  constructor(data: FilterProps) {
    this.data = {
      filter: {
        filter_operator:
          (data.mainOperator?.toLowerCase() as MainOperatorEnum) ||
          MainOperatorEnum.And,
        filters: [],
      },
    };

    this.data.filter.filters = data.conditions?.map((clause) => {
      if ('mainOperator' in clause) {
        return {
          filter_operator:
            clause.mainOperator?.toLowerCase() as MainOperatorEnum,
          filters: clause.conditions?.map(
            (nestedClause: SingleFilterClause) => ({
              name: nestedClause.property.name,
              operator: nestedClause.operator.name,
              value: handleValueField(nestedClause.value),
            })
          ),
        };
      }
      return {
        name: clause.property?.name,
        operator: clause.operator?.name,
        value: handleValueField(clause.value),
      };
    });
  }
  generateBodyPayload() {
    return this.data;
  }
}

function handleValueField(value: any) {
  if (Array.isArray(value)) {
    return value.map((item: any) => item.value);
  }
  return value;
}
